import _ from 'lodash';
import { useUser } from '@lore/auth';
import useGetCount from '@/pages/explore/useGetCount';

// Educators
import relatedEducators from '@/pages/educators-filtered/related/useQuery';
import sitesEducators from '@/pages/educators-filtered/sites/useQuery';
import relatedAffiliationEducators from '@/pages/educators-filtered/related-affiliation/useQuery';
import starredEducators from '@/pages/educators-filtered/starred/useQuery';
import incompleteEducators from '@/pages/educators-filtered/incomplete/useQuery';
import newEducators from '@/pages/educators-filtered/new/useQuery';
import sleepingEducators from '@/pages/educators-filtered/sleeping/useQuery';
import inactiveEducators from '@/pages/educators-filtered/inactive/useQuery';

export default function getNavigationLinks() {
  const currentUser = useUser();
  const showAll = !currentUser.lowerNetworkBarriers

  return _.compact([
    showAll && { id: "all", name: 'All', href: `/educators` },
    { id: "connected", name: 'Connected to your sites', href: `/educators/related-affiliation`, count: useGetCount(relatedAffiliationEducators) },
    { id: "creating", name: 'Creating at your sites', href: `/educators/related`, count: useGetCount(relatedEducators) },
    { id: "nearby", name: 'Nearby but not affiliated with a site', href: `/educators/sites`, count: useGetCount(sitesEducators) },
    currentUser.data.isSuperuser && { id: "engagement", name: '[Engagement]', href: `/educators/engagement` },
    { id: "starred", name: 'Starred', href: `/educators/starred`, count: useGetCount(starredEducators) },
    { id: "new", name: 'New', href: `/educators/new`, count: useGetCount(newEducators), highlight: true },
    { id: "sleeping", name: 'Sleeping', href: `/educators/sleeping`, count: useGetCount(sleepingEducators) },
    { id: "inactive", name: 'Inactive', href: `/educators/inactive`, count: useGetCount(inactiveEducators) },
    { id: "incomplete-profile", name: 'Incomplete Profile', href: `/educators/incomplete`, count: useGetCount(incompleteEducators) },
  ]);
}
